module.exports = __webpack_public_path__ + "static/Behir-13912cc40b517667c298712637219218.jpg";